// Module
var code = "<div class=\"flex layout-column md-whiteframe-z1 mn-module\" mn-bind-html=\"dental-consultation/views/dental-container.html\">\n</div>";
// Exports
module.exports = code;